import axios from "axios";
import {
  handleUnauthorizedError,
  handleForbiddenError,
} from "../utils/authUtils";
import envConfig from "../config/environment";

// Auto-detect environment - no manual configuration needed!
const myAxios = axios.create({
  baseURL: envConfig.getApiUrl(),
  timeout: 30000, // 30 seconds timeout for requests
  maxContentLength: 5 * 1024 * 1024, // 5MB max content length
  maxBodyLength: 5 * 1024 * 1024, // 5MB max body length
});

myAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Enhanced response interceptor to handle 401 errors with better UX
myAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors (including expired tokens)
    if (
      error.response &&
      error.response.status === 401 &&
      ((error.response.data?.error &&
        error.response.data.error.toLowerCase().includes("expired")) ||
        error.response.data?.code === "ADMIN_TOKEN_EXPIRED" ||
        error.response.data?.message?.toLowerCase().includes("unauthorized"))
    ) {
      handleUnauthorizedError(error);
      return Promise.reject(
        new Error("Authentication failed - redirected to login")
      );
    }

    // Handle 403 Forbidden errors
    if (error.response?.status === 403) {
      handleForbiddenError(error);
    }

    return Promise.reject(error);
  }
);

export default myAxios;
